import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PackageJson from "../../package.json";

export default function useCacheBuster() {
  const location = useLocation();
  //   const parseVersion = (str: string) => +str.replace(/\D/g, "");

  useEffect(() => {
    fetch(`/meta.json?v=${+new Date()}`, { cache: "no-cache" })
      .then((response) => response.json())
      .then((meta) => {
        if (meta?.version) {
          if (PackageJson.version !== meta.version) {
            if (window?.location?.reload) {
              window.location.reload();
            }
          }
        }
      })
      .catch((error) => {
        console.error("something went wrong fetching meta.json", error);
      });
  }, [location]);

  return null;
}
